import { ReactComponent as NodeOn } from "./icon/street-light-on.svg";
import { ReactComponent as NodeError } from "./icon/street-light-error.svg";
import { ReactComponent as NodeOff } from "./icon/street-light-off.svg";
import { eDeviceState } from "../../../common/constants";
import { INodeInfo } from ".";

interface INodeMarkerProps {
  id: number;
  node: INodeInfo;
  handleClick: (node: INodeInfo) => void;
  zoom: number;
}

const NodeMarker = ({
  id,
  node,
  handleClick,
  zoom,
  ...props
}: INodeMarkerProps) => {
  const renderIcon = (state: eDeviceState) => {
    switch (state) {
      case eDeviceState.ERROR:
        return <NodeError />;
      case eDeviceState.NORMAL:
        return <NodeOff />;
      case eDeviceState.LIGHT_ON:
        return <NodeOn />;
    }
  };
  return (
    <div
      className="flex flex-col items-center justify-center relative cursor-pointer"
      title={`Node ${node.nodes.id} - ${node.nodes.serialNumber}`}
      onClick={() => handleClick(node)}
    >
      <div className="text-sm relative font-medium text-[#964F19] whitespace-nowrap bg-neutral-White">
        {node.nodes.serialNumber}
      </div>
      {renderIcon(node.currentState)}
      {zoom > 17 && <div className="text-xs relative font-medium text-[#964F19] whitespace-nowrap bg-neutral-White">
        ID: {node.nodes.id}
      </div>}
    </div>
  );
};
export default NodeMarker; 